import React from "react";
import { Link } from 'react-router-dom';
import OpenSeadragon from 'openseadragon';

import { AppContext } from '../util';
import config from '../config';

class DetailView extends React.Component {

    static contextType = AppContext;

    constructor(props) {
        super(props);

        this.osd = React.createRef();
        this.osdViewer = null;
    }

    componentDidMount() {

        const filename = this.props.match.params.id.replace(/-/g, '');

        //hotfix: add a timeout if the mounting div is not available yet.
        //this happens when the app is opened with a detail URL
        const timeout = this.osd.current ? 0 : 1000;

        //init OpenSeaDragon
        (function(dat) {
            window.setTimeout(function() {
                dat.osdViewer = OpenSeadragon({
                    element: dat.osd.current,
                    showNavigationControl: false,
                    showZoomControl: false,
                    showHomeControl: false,
                    showFullPageControl: false,
                    showRotationControl: false,
                    showSequenceControl: false,
                    tileSources: {
                        type: 'image',
                        url:  `${config.paths.full}${filename}.png`
                    }
                });
            }, timeout);
        })(this);
        
    }

    componentDidUpdate(prevProps) {

        if(!this.osdViewer) return;
        if(this.props.match.params.id === prevProps.match.params.id) return;

        const filename = this.props.match.params.id.replace(/-/g, '');

        //update OpenSeaDragon
        this.osdViewer.open({
            type: 'image',
            url:  `${config.paths.full}${filename}.png`
        });
    }

    handleExit = (e) => {

        const view = this.props.match.params.view ? this.props.match.params.view + '/' : '';
        this.props.history.push(`/${view}`);
    }

    render() {

        const classes = 'detail';
        const view = this.props.match.params.view ? this.props.match.params.view + '/' : '';
        
        return (
            <AppContext.Consumer>
                {({data}) => {

                let prevId, nextId;
                const rowIndex = data.findIndex(item => item.workID === this.props.match.params.id);
                if(rowIndex < 0 ) return null;

                const row = data[rowIndex];
                if(rowIndex === 0) {
                    prevId = data[data.length-1].workID;
                } else {
                    prevId = data[rowIndex-1].workID;
                }

                if(rowIndex === data.length-1) {
                    nextId = data[0].workID;
                } else {
                    nextId = data[rowIndex+1].workID;
                }

                let imgClass = 'detail__image';
                const filename = row.workID.replace(/-/g, '');

                return (
                    <section className={classes}>
                        <div className='detail__nav'>
                            {prevId && <Link to={`/detail/${prevId}/${view}`}><img className='arrow arrow--prev' src='/images/icon-arrow.svg' /></Link>}
                        </div>
                        <div className='detail__media'>
                            {/*<img ref={this.image} className={imgClass} src={`${config.paths.full}${filename}.png`} />*/}
                            <div className="detail__osd" ref={this.osd} id="detail-osd"></div>
                        </div>
                        <div className='detail__text'>
                            <div className="detail__year">{row.year}</div>
                            <div className="detail__artist">{row.actorInRole}</div>
                            <div className="detail__title">{row.title}</div>
                            
                            <div className="detail__meta">
                                {row.objectWorkType && <p>{row.objectWorkType}</p>}
                                {row.widthInCm && row.heightInCm && <p>
                                    {row.widthInCm}&nbsp;cm &times; {row.heightInCm}&nbsp;cm
                                </p>}
                                {row.thirdparty && <p>Dauerleihgabe</p>}
                            </div>
                        </div>
                        <div className='detail__nav'>
                            {nextId && <Link to={`/detail/${nextId}/${view}`}><img className='arrow arrow--next' src='/images/icon-arrow.svg' /></Link>}
                        </div>
                        <div className='detail__close' onClick={this.handleExit}>
                            <img className='' src='/images/icon-close.svg' />
                        </div>
                        <div className="detail__background" onClick={this.handleExit}></div>
                    </section>
                )}}
            </AppContext.Consumer>
        )
    }
}

export default DetailView;